import { attributes } from "@type-r/models";

export type Address = InstanceType<typeof Address>;
export const Address = attributes({
    line1: String,
    line2: String,
    city: String,
    stateProvince: String,
    postalCode: String,
    countryCode: String,
});